<template>
    <div class="animated fadeIn equipmentDetail bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :variableWidth="true" 
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            label="Save"
                            @click="save"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <gofix-card classContent="mb-0 mt-4">
                            <b-row>
                                <b-col md="4">
                                    <gofix-form-properties
                                        disabled="disabled"
                                        valueFormat="object"
                                        label="Location"
                                        :clearable="false"
                                        required
                                        :contract-id="$route.params.id"
                                        v-model="locationIdModal">
                                    </gofix-form-properties>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field class="editEndValue mt-10" label="Location Map" oneline>
                                        <template slot="gofixTextField:after_value">
                                            <gofix-button class="editRight" label="Edit" @click="showModalPhoto('location_maps')" noBorder fontNormal small></gofix-button>
                                        </template>
                                        <div class="photosThumb photosThumbEquipment mt-0">
                                            <template v-if="equipment.location_maps">
                                                <viewer-image :images="equipment.location_maps">
                                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                        <ul class="list-thumb">
                                                            <li v-for="(item,key) in images" v-if="key<=4"  v-bind:key="key">
                                                                <img v-if="key < 4" v-auth-image="item.url.original" alt="" src="img/loading.gif">
                                                                <img v-if="key === 4" v-auth-image="item.url.original" alt="" src="img/loading.gif">
                                                                <span class="pointer-event-none" v-if="equipment.location_maps.length > 5 && key === 4">{{equipment.location_maps.length-5}}+</span>
                                                            </li>
                                                        </ul>
                                                    </template>
                                                </viewer-image>
                                            </template>
                                        </div>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="4"> </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card classContent="mb-0 mt-4">
                            <b-row class="mt-10">
                                <b-col md="4">
                                    <gofix-form-tree
                                        disabled="disabled"
                                        label="Equipment Group"
                                        :options="equipmentGroups"
                                        :load-options="loadOptionsGroup"
                                        :clearable="false"
                                        placeholder=""
                                        required
                                        v-model="equipmentGroupSelected"
                                        :normalizer="normalizerGroup"
                                        search-nested
                                        valueFormat="object">
                                    </gofix-form-tree>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Brand"
                                        vLabel="name"
                                        :filterable="false"
                                        @search="searchEquipmentBrand"
                                        v-model="equipmentBrandSelected"
                                        :options="equipmentBrand">
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <span class="color-000">{{ option.name }}</span>
                                        </template>
                                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                            <span class="color-000">{{ option.name }}</span>
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Model"
                                        vLabel="name"
                                        :filterable="false"
                                        @search="searchEquipmentModel"
                                        :disabled="!equipmentBrandSelected"
                                        v-model="equipmentModelSelected"
                                        :options="equipmentModel">
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <span class="color-000">{{ option.name }}</span>
                                        </template>
                                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                            <span class="color-000">{{ option.name }}</span>
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <gofix-form-input label="Serial Number" v-model="equipment.serial_number"></gofix-form-input>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input disabled="disabled" label="Equipment Location Tag" v-model="equipment.tag_name" required></gofix-form-input>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Tags"
                                        taggable
                                        multiple
                                        push-tags
                                        v-model="equipment.tags"
                                        :options="[]">
                                        <template slot="gofixInput:dropdown:no-options" slot-scope="{search, searching, loading}">
                                            Please entering a value to add a tag
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                            <b-row class="pb-30">
                                <b-col md="4">
                                    <gofix-text-field class="mb-3 pl-0 editEndValue" label="Service Tag" oneline>
                                        <template slot="gofixTextField:after_value">
                                            <gofix-button class="editRight" label="Edit" @click="showModalPhoto('service_tags')" noBorder fontNormal small></gofix-button>
                                        </template>
                                        <div class="photosThumb photosThumbEquipment mt-0">
                                            <template v-if="equipment.service_tags">
                                                <viewer-image :images="equipment.service_tags">
                                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                        <ul class="list-thumb">
                                                            <li v-for="(item,key) in images" v-if="key<=4"  v-bind:key="key">
                                                                <img v-if="key < 4" v-auth-image="item.url.original" alt="" src="img/loading.gif">
                                                                <img v-if="key === 4" v-auth-image="item.url.original" alt="" src="img/loading.gif">
                                                                <span class="pointer-event-none" v-if="equipment.service_tags.length > 5 && key === 4">{{equipment.service_tags.length-5}}+</span>
                                                            </li>
                                                        </ul>
                                                    </template>
                                                </viewer-image>
                                            </template>
                                        </div>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field class="mb-3 pl-0 editEndValue" label="Manufacturer Tag" oneline>
                                        <template slot="gofixTextField:after_value">
                                            <gofix-button class="editRight" label="Edit" @click="showModalPhoto('manufacturer_tags')" noBorder fontNormal small></gofix-button>
                                        </template>
                                        <div class="photosThumb photosThumbEquipment photo mt-0">
                                            <template v-if="equipment.manufacturer_tags">
                                                <viewer-image :images="equipment.manufacturer_tags">
                                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                        <ul class="list-thumb">
                                                            <li v-for="(item,key) in images" v-if="key<=4"  v-bind:key="key">
                                                                <img v-if="key < 4" v-auth-image="item.url.original" alt="" src="img/loading.gif">
                                                                <img v-if="key === 4" v-auth-image="item.url.original" alt="" src="img/loading.gif">
                                                                <span class="pointer-event-none" v-if="equipment.manufacturer_tags.length > 5 && key === 4">{{equipment.manufacturer_tags.length-5}}+</span>
                                                            </li>
                                                        </ul>
                                                    </template>
                                                </viewer-image>
                                            </template>
                                        </div>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card classContent="mb-0 mt-4">
                            <b-row>
                                <b-col md="2">
                                    <gofix-form-input-date
                                        v-model="equipment.purchase_date"
                                        popoverDirection="top"
                                        label="Purchase Date">
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-number
                                        label="Purchase Price"
                                        v-model="equipment.purchase_price"
                                        prefix="$"></gofix-form-input-number>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-date
                                        desc="dd.mm.yyyy"
                                        popoverDirection="top"
                                        v-model="equipment.installation_date"
                                        label="Installation Date">
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-number
                                        label="Installation Price"
                                        v-model="equipment.installation_price"
                                        prefix="$"></gofix-form-input-number>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-date
                                        popoverDirection="top"
                                        desc="dd.mm.yyyy"
                                        disabled
                                        v-model="equipment.warranty_expiry"
                                        label="Warranty Expiry Date">
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-number
                                        label="Warranty Period [Months]"
                                        :includeThousandsSeparator="false"
                                        :allowDecimal="false"
                                        v-model="equipment.warranty_period">
                                    </gofix-form-input-number>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <equipment-custom-fields ref="equipmentCustomFields" v-model="equipment.custom_fields"></equipment-custom-fields>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Equipment" title="New Brand" hide-footer :centered="true" ref="add-modal-new-branch">
            <b-form class="pb-20">
                <gofix-form-input  label="Branch Name"  v-model="brandNew"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="ADD" @click="saveEquipBrands" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Equipment" title="New Model" hide-footer :centered="true" ref="add-modal-new-model" >
            <b-form class="pb-20">
                <gofix-form-input  label="Model Name"  v-model="modelNew"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="ADD" @click="saveEquipModel" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--Edit photos-->
        <b-modal :no-close-on-backdrop="true" id="modal-EditPhoto" title="Edit Photos" hide-footer :centered="true" ref="modal-EditPhoto" v-model="modals.open">
            <b-form >
                <b-form-group label="Photos" class="photosThumb mt-0">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in modals[modals.type].attachments" v-bind:key="key"><img v-auth-image="item.url.thumb" src="img/loading.gif" alt=""> <span  class="delete" @click="deleteAttachment(item)" ><img src="img/close.png" alt=""></span></li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file id="fileInputMulti" v-model="modals[modals.type].attachment" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="uploadPhotos" :loading="modals.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
    import { mapGetters } from "vuex";
    const EquipmentCustomFields = () => import("./equipment-custom-fields");
    const ViewerImage = () => import('@/views/plugins/ViewerImage.vue');
    import moment from 'moment';
    const accounting = require('accounting');
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500);
    };

    export default {
        name: 'basicInfo',
        data() {
            return {
                tabData: [
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                locationIdModal: null,
                dataLocationModal: [],
                equipmentGroups: [],
                equipmentGroupSelected: null,
                equipmentType: [],
                equipment: {
                    location: "",
                    location_id: "",
                    equipment_category: "",
                    equipment_category_id: "",
                    equipment_type: "",
                    equipment_group_id: "",
                    serial_number: "",
                    brand: "",
                    brand_id: "",
                    model: "",
                    model_id: "",
                    tag_name: "",
                    purchase_date: null,
                    installation_date: null,
                    warranty_expiry: null,
                    purchase_price: "",
                    installation_price: "",
                    previous_equipment: "",
                    contract_id: this.$route.params.id,
                    custom_fields: [],
                    location_maps: [],
                    service_tags: [],
                    manufacturer_tags: [],
                    is_active: false,
                    tags: "",
                    warranty_period: null
                },
                equipmentBrand: [],
                equipmentBrandSelected: null,
                equipmentModel: [],
                equipmentModelSelected: null,
                brandSearch: {
                    status: false,
                    name: ""
                },
                modelSearch: {
                    status: false,
                    name: ""
                },
                brandNew: "",
                modelNew: "",
                modal: false,
                type_brand_id: '',
                isEdit: {
                    Type: false,
                    Brand: false,
                    Model: false,
                    Categoty: false
                },
                isLoad: false,
                timer: {
                    brand: null,
                    model: null
                },
                modals: {
                    type: "location_maps",
                    loading: false,
                    open: false,
                    location_maps: {
                        attachment: null,
                        attachments: [],
                        data: {
                            photos: [],
                            del_ids: []
                        },
                    },
                    service_tags: {
                        attachment: null,
                        attachments: [],
                        data: {
                            photos: [],
                            del_ids: []
                        },
                    },
                    manufacturer_tags: {
                        attachment: null,
                        attachments: [],
                        data: {
                            photos: [],
                            del_ids: []
                        },
                    }
                },
                liftOnTurnDate: null
            }
        },
        components: {
            "equipment-custom-fields": EquipmentCustomFields,
            "viewer-image": ViewerImage,
        },
        computed: {
            ...mapGetters({
                detaiEquipment: "EquipmentV2Controller/equipment",
                ClientContractID: "ContractController/ClientContractID"
            })
        },
        created() {
            if (!this.$route.params.hasOwnProperty('equipment_id')) {
                this.tabData[1].disabled = this.tabData[2].disabled = true;
            }

            if(!this.$checkRole(this.$accessModule.parts_replacement, 'read')) {
                this.tabData[2].disabled = true;
            }

            if (this.$route.params.hasOwnProperty('equipment_id') && this.$route.params.equipment_id != 'add') {
                this.isEdit = {
                    Type: true,
                    Brand: true,
                    Model: true,
                    Categoty: true,
                }

                this.getEquipment();
            } else if (this.detaiEquipment) {
                this.isEdit = {
                    Type: true,
                    Brand: true,
                    Model: true,
                    Categoty: true,
                }
                this.detailItem(this.detaiEquipment);
            }

            this.getEquipmentCategory();
            this.getEquipmentBrand();
        },
        watch: {
            ClientContractID: function (val, old) {
                if (Object.keys(old).length > 0 && val && this.$route.params.equipment_id != 'add') {
                    return this.$router.push(`/v2/contract-client/${this.$route.params.id}/equipment`)
                }
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }

                if (old && val && old.id && val.id && old.id != val.id)
                    this.getEquipmentCategory();
            },
            detaiEquipment: function (val) {
                if (val) {
                    this.detailItem(val);
                }
            },
            equipmentGroupSelected: function (val, old) {
                if (val) {
                    if ((old && val.id !== old.id) || !this.$route.params.equipment_id) {
                        this.getCustomFields(val.id);
                    }
                }
            },
            equipmentBrandSelected: function (val, old) {
                if (!val) {
                    this.equipmentModelSelected = null;
                    this.equipmentModel = [];
                }

                if (val && val.id) this.getEquipmentModel();
            },
            "modals.location_maps.attachment": function (val, old) {
                this.attachmentFileChange(val, "location_maps");
            },
            "modals.service_tags.attachment": function (val, old) {
                this.attachmentFileChange(val, "service_tags");
            },
            "modals.manufacturer_tags.attachment": function (val, old) {
                this.attachmentFileChange(val, "manufacturer_tags");
            }
        },
        methods: {
            getEquipmentCategory() {
                this.isLoad = true
                this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
                    id: 0,
                    contract_id: this.$route.params.id
                }).then(response => {
                    if (this.detaiEquipment && this.$route.params.equipment_id == 'add')
                        this.isEdit.Categoty = false;
                    this.isLoad = false
                    this.equipmentGroups = response.data.data;
                });
            },
            searchEquipmentBrand(search, loading) {
                loading(true);
                this.equipmentBrand = []
                if (this.timer.brand) {
                    clearTimeout(this.timer.brand);
                    this.timer.brand = null;
                }
                this.timer.brand = setTimeout(async () => {
                    try {
                        await this.getEquipmentBrand(search);
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 300);
            },
            async getEquipmentBrand(search = '') {
                await this.$store.dispatch("MasterBrandController/getItems", {
                    limt: 100,
                    sortColumn: "name",
                    sortDirection: "ASC",
                    filter: {
                        name: search,
                        contract_id: this.$route.params.id,
                    }
                })
                .then(response => {
                this.equipmentBrand = response.items;
                    if (!this.equipmentBrand.length && search) {
                        this.equipmentBrandSelected = {
                        id: 0,
                        name: search
                        }
                    }
                });
            },
            searchEquipmentModel(search, loading) {
                loading(true);
                this.equipmentModel = []
                if (this.timer.model) {
                    clearTimeout(this.timer.brand);
                    this.timer.model = null;
                }
                this.timer.model = setTimeout(async () => {
                    try {
                        await this.getEquipmentModel(search);
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 300);
            },
            async getEquipmentModel(search = '') {
                if (this.equipmentBrandSelected && this.equipmentBrandSelected.id) {
                    await global.axios(`api/equipment/models?type_brand_id=${this.equipmentBrandSelected.id}`, {
                        method: "GET",
                        params: {
                            search: search
                        },
                        headers: {
                        Accept: "application/json"
                        }
                    })
                    .then(response => {
                        this.equipmentModel = response.data.data;
                            if (!this.equipmentModel.length && search) {
                                this.equipmentModelSelected = {
                                    id: 0,
                                    name: search,
                                    type_brand_id: this.equipmentBrandSelected.id
                                }
                            }
                    })
                    .catch(error => {
                        console.log(error);
                    });
                } else {
                    if (search) {
                        this.equipmentModelSelected = {
                            id: 0,
                            name: search,
                            type_brand_id: this.equipmentBrandSelected.id
                        }
                    }
                }
            },
            normalizerGroup(node) {
                if (node.isBatch)
                return {
                    id: node.id,
                    label: node.name,
                    children: node.children,
                };
                return {
                    id: node.id,
                    label: node.name,
                    children: undefined,
                };
            },
            loadOptionsGroup({action, parentNode, callback}) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return;
                    }
                    if (parentNode.isBatch) {
                        this.$store
                            .dispatch("EquipmentV2Controller/getEquipmentCategory", {
                            id: parentNode.data.id,
                            contract_id: this.$route.params.id
                            })
                            .then(response => {
                            simulateAsyncOperation(() => {
                                parentNode.children = response.data.data;
                                callback();
                            });
                            });
                    } else {
                        parentNode.children = [];
                        callback();
                    }
                }
            },
            async getEquipment() {
                await this.$store.dispatch('EquipmentV2Controller/getEquipment', this.$route.params.equipment_id)
                .catch(async error => {
                    await this.$router.push(`/v2/contract-client/${this.$route.params.id}/equipment`);
                    await this.$alertNotification("Equipment doesn't exist", "danger");
                })
            },
            detailItem(detail) {
                detail.installation_price = detail.installation_price ? this.$accounting.formatMoney(detail.installation_price) : 0;
                detail.purchase_price = detail.purchase_price ? this.$accounting.formatMoney(detail.purchase_price) : 0;
                detail.purchase_date = detail.purchase_date ? new Date(detail.purchase_date) : null;
                detail.installation_date = detail.installation_date ? new Date(detail.installation_date) : null;
                detail.warranty_expiry = detail.warranty_expiry ? new Date(detail.warranty_expiry) : null;
                detail.location_maps = detail.location_maps ? detail.location_maps : [];
                detail.service_tags = detail.service_tags ? detail.service_tags : [];
                detail.manufacturer_tags = detail.manufacturer_tags ? detail.manufacturer_tags : [];
                this.equipment = detail;

                if (detail.location_info) {
                    this.locationIdModal = detail.location_info;
                } else if (detail.location_id) {
                    this.locationIdModal = {
                        id: detail.location_id,
                        name: detail.location,
                    };
                }

                if (detail.equipment_group_id)
                    this.equipmentGroupSelected = {
                        id: detail.equipment_group_id,
                        name: detail.equipment_type,
                        text: detail.equipment_type,
                        data: {
                            id: detail.equipment_group_id,
                            name: detail.equipment_type,
                            text: detail.equipment_type
                        },
                        children: null
                    };

                this.equipmentBrandSelected = null;
                this.equipmentModelSelected = null;

                /* reset current equipment */
                this.equipment.serial_number = ''
                this.equipment.location_maps = []
                this.equipment.service_tags = []
                this.equipment.manufacturer_tags = []
                this.equipment.purchase_date = null
                this.equipment.purchase_price = null 
                this.equipment.installation_price = null
                this.equipment.warranty_period = null
                this.equipment.installation_date = null
                this.equipment.tags = null

                let filter = this.equipment.custom_fields.filter(item => {
                    if(item.attribute && item.attribute.name.toLowerCase() == 'lift turn on date' && item.attribute.type == 'DateTime') return item
                })
                if(filter.length && filter[0].value) {
                    this.liftOnTurnDate = filter[0].value;
                }

                this.equipment.custom_fields.map(async (item, key) => {
                    if(item.attribute && ['tc code','hdb','cn','postal code','prefix','block no','lift no','street name','constituency','grc','building storey','lift type'].includes(item.attribute.name.toLowerCase())) {
                        return item
                    }
                    item.value = null
                    return item
                })
            },
            async save() {

                // if(this.equipmentGroupSelected && this.equipmentGroupSelected.name && this.equipmentGroupSelected.name.toLowerCase() == 'lift') {
                //     let arrTmp = [];
                //     if(this.equipment.custom_fields && this.equipment.custom_fields.length) {
                //         arrTmp = this.equipment.custom_fields.filter(item => {
                //             if(item.attribute && item.attribute.name.toLowerCase() == 'lift turn on date' && item.attribute.type == 'DateTime') return item
                //         })
                //     }
                //     if( (arrTmp[0] && !arrTmp[0].value) && !this.equipment.serial_number) {
                //         return this.$alertNotification("Please ensure that either the Serial Number or Lift Turn On Date are input in the system before you can proceed with the shutdown!", "warning");
                //     }
                // }
                
                if (!this.locationIdModal)
                    return this.$alertNotification("Loacation is a required field.", "danger");

                if (!this.equipment.tag_name)
                    return this.$alertNotification("Tag name is a required field.", "danger");
                
                if(this.liftOnTurnDate) {
                    if(this.equipment.custom_fields && this.equipment.custom_fields.length) {
                        let arrTmp = this.equipment.custom_fields.filter(item => {
                            if(item.attribute && item.attribute.name.toLowerCase() == 'lift turn on date' && item.attribute.type == 'DateTime') return item
                        })

                        if( arrTmp[0] && arrTmp[0].value && moment(arrTmp[0].value).isSame(this.liftOnTurnDate)) {
                            return this.$alertNotification("Lift turn on date must have a different value from lift turn on date of the shutdown equipment", "warning");
                        }
                    }
                }

                let equipment = Object.assign({}, this.equipment);
                equipment.brand = this.equipmentBrandSelected ? this.equipmentBrandSelected.name : '';
                equipment.brand_id = this.equipmentBrandSelected ? this.equipmentBrandSelected.id : '';
                equipment.equipment_type = this.equipmentGroupSelected ? this.equipmentGroupSelected.name : '';
                equipment.equipment_group_id = this.equipmentGroupSelected ? this.equipmentGroupSelected.id : '';
                equipment.location = this.locationIdModal.name;
                equipment.location_id = this.locationIdModal.id;
                equipment.model = this.equipmentModelSelected ? this.equipmentModelSelected.name : '';
                equipment.model_id = this.equipmentModelSelected ? this.equipmentModelSelected.id : '';
                if (equipment.purchase_date) equipment.purchase_date = moment(equipment.purchase_date).format('YYYY-MM-DD');

                equipment.purchase_date = equipment.purchase_date ? moment(equipment.purchase_date).format('YYYY-MM-DD') : '';
                equipment.purchase_price = equipment.purchase_price ? this.$accounting.unformat(equipment.purchase_price) : '';
                equipment.installation_price = equipment.installation_price ? this.$accounting.unformat(equipment.installation_price) : '';
                equipment.installation_date = equipment.installation_date ? moment(equipment.installation_date).format('YYYY-MM-DD') : '';
                equipment.warranty_expiry = equipment.warranty_expiry ? moment(equipment.warranty_expiry).format('YYYY-MM-DD') : ''

                equipment.location_maps = this.modals.location_maps.data.photos;
                equipment.service_tags = this.modals.service_tags.data.photos;
                equipment.manufacturer_tags = this.modals.manufacturer_tags.data.photos;

                equipment.custom_fields = equipment.custom_fields ? JSON.stringify(equipment.custom_fields) : null;

                delete equipment.id
                delete equipment.created_by
                delete equipment.deleted_at
                delete equipment.deleted_by
                delete equipment.updated_at
                delete equipment.updated_by
                
                let dataStatus = {
                    id: this.equipment.id,
                    data: {
                        update_equipment_status: 'Replaced',
                        check_next_action: true,
                        ...equipment
                    },
                }
                
                await this.$store.dispatch("EquipmentV2Controller/statusEquipment", dataStatus)
                .then(response => {

                    /* status 200 */
                    dataStatus.data.check_next_action = false

                    this.$store.dispatch("EquipmentV2Controller/statusEquipment", dataStatus)
                    .then(response => {
                        if ( response.equipment_new.id ) {
                            this.equipment.id = response.equipment_new.id;
                            this.$router.push(`/v2/contract-client/${this.$route.params.id}/equipment/${response.equipment_new.id}`);
                        }
                    })
                    .catch(err => {
                        if (err.response.data.error && err.response.data.error.message.error.error) {
                            this.$alertNotification(err.response.data.error.message.error.error, "danger")
                        } else {
                            if (err.response.data.error && err.response.data.error.message.error) {
                                this.$alertNotification(err.response.data.error.message.error, "danger")
                            }
                        }
                        this.modalsAction.status = false
                        this.modalsAction.loading = false
                    })
                })
                .catch(err => {
                    if (err.response.data.error && err.response.data.error.message.error.error) {
                        this.$alertNotification(err.response.data.error.message.error.error, "danger")
                    } else {
                        if (err.response.data.error && err.response.data.error.message.error) {
                            this.$alertNotification(err.response.data.error.message.error, "danger")
                        }
                    }
                    this.modalsAction.status = false
                    this.modalsAction.loading = false
                })
            },
            async saveEquipBrands() {
                let Brand = await global.axios(`api/equipment/brands`, {
                method: "POST",
                data: {
                    contract_id: this.$route.params.id,
                    name: this.equipmentBrandSelected.name
                },
                headers: {
                    Accept: "application/json",
                }
                });
                this.$alertNotification(this.$notificationV2('adding', 'brand'));
                this.equipmentBrand.push(Brand.data.data);
                this.equipmentBrandSelected = Brand.data.data,
                this.equipmentModel = [];
                this.equipmentModelSelected = null;
                this.brandSearch.status = false;
                this.$refs['add-modal-new-branch'].hide()
            },
            async saveEquipModel() {
                let equipmentModel = await global.axios(`api/equipment/models`, {
                    method: "POST",
                    data: {
                        name: this.modelNew,
                        type_brand_id: this.equipmentBrandSelected.pivot.id
                    },
                    headers: {
                        Accept: "application/json",
                    }
                });
                this.$alertNotification(this.$notificationV2('adding', 'model'));
                this.equipmentModel.push(equipmentModel.data.data);
                this.equipmentModelSelected = equipmentModel.data.data;
                this.modelSearch.status = false;
                this.$refs['add-modal-new-model'].hide()
            },
            openModel() {
                if (!this.equipmentBrandSelected) {
                    return this.$alertNotification("Please select equipment brand", "danger");
                }
                this.$refs['add-modal-new-model'].show()
            },
            getCustomFields(equipment_group_id) {
                this.$store.dispatch('EquipmentV2Controller/getCustomFields', {
                    equipment_group_id: equipment_group_id,
                }).then(response => {
                    this.equipment.custom_fields = response;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            attachmentFileChange(val, type) {
                if (val) {
                    val.forEach((file, index) => {
                        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }

                        file.moment = moment().valueOf() + index;
                        let data = {
                            moment: moment().valueOf() + index,
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file)
                            }
                        };

                        this.modals[type].data.photos.push(file);
                        this.modals[type].attachments.push(data);
                    });
                }
            },
            showModalPhoto(type) {
                this.modals.type = type;
                this.modals[this.modals.type].attachment = null;
                this.modals[this.modals.type].attachments = JSON.parse(JSON.stringify(this.equipment[this.modals.type]));
                
                if(!this.modals[this.modals.type].data.photos){
                    this.modals[this.modals.type].data.photos = [];
                }
                if(!this.modals[this.modals.type].data.del_ids){
                    this.modals[this.modals.type].data.del_ids = [];
                }
                
                this.modals.open = true;
            },
            uploadPhotos() {
                this.equipment[this.modals.type] = this.modals[this.modals.type].attachments
                this.modals.loading = false;
                this.modals.open = false;
            },
            deleteAttachment(img) {
                this.modals[this.modals.type].attachments = this.modals[this.modals.type].attachments.filter(item => item.moment !== img.moment);
                this.modals[this.modals.type].data.photos = this.modals[this.modals.type].data.photos.filter(item => item.moment !== img.moment)
            }
        }
    }
</script>